export default function useSetShare() {
    const handleShareButton = () => {
        if (navigator.share) {
            navigator.share({
                url: 'https://hamyanapp.com/download',
                title: 'همیان | حسابداری آنلاین صندوق های فامیلی',
            })
        } else {
        }
    }
    return { handleShareButton }
}
